export function CSVExport(data, filename = "export.csv") {
    if (!data.length) return;

    // Oszlopnevek
    const headers = Object.keys(data[0]);
    // CSV sorok
    const csvRows = [
        headers.join(";"), // Magyar Excelhez célszerű pontosvessző
        ...data.map(obj => headers.map(header => {const value = obj[header] ?? ""; return `"${String(value).replace(/"/g, '""')}"`;}).join(";"))
    ];
    const csvString = "\uFEFF" + csvRows.join("\n"); // UTF-8 BOM az Excel miatt
    const blob = new Blob([csvString], {type: "text/csv;charset=utf-8;"});
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
}